import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import BranchTransferReceiveFilters from "./components/BranchTransferReceiveFilters";
import BranchTransferReceiveTable from "./components/BranchTransferReceiveTable";
import "./style.css";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { exportBranchTransferReceiveCsv } from "./components/exportBranchTransferReceiveCsv";

const { Title } = Typography;

const BranchTransferReceiveList = () => {
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters, list } = useSelector(
    (state) => state.branchTransferReceive
  ); 
  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Branch Tarnsaction Received List",
    removeAfterPrint: true,
  });
 const handleDownloadCsv = () => {
    exportBranchTransferReceiveCsv({
      list,
      filters,
      title:    "Branch Transaction Received List",
      filename: "branch_transfer_receive",
    });
  };

  const hasData = list.length > 0;

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <Title level={4} style={{ margin: 0 }} className="reportBigTitle" >
              Branch Transaction Received List
            </Title>
          }
          extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <BranchTransferReceiveFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <BranchTransferReceiveTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Loan Balance Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <BranchTransferReceiveTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default BranchTransferReceiveList;
